export default __webpack_public_path__ + "static/validate_img-dfdf5e8c28d452625fee582483ed04b1.svg";